import { SyncTableConfig } from "./types";
import { SMART_CONTEXTS_TABLE_CONFIG } from "./smart-contexts";
import { SMART_VIEWS_TABLE_CONFIG } from "./smart-views";
import { SMART_CARDS_TABLE_CONFIG } from "./smart-cards";

export const SYNC_TABLES: SyncTableConfig[] = [
  SMART_CONTEXTS_TABLE_CONFIG,
  SMART_VIEWS_TABLE_CONFIG,
  SMART_CARDS_TABLE_CONFIG,
];

export type { SyncTableConfig } from "./types";
